const STORAGE_VERSION = '2';

export function clearStaleStorage() {
  const storedVersion = localStorage.getItem('app-version');
  if (storedVersion !== STORAGE_VERSION) {
    localStorage.removeItem('recoil-persist');
    localStorage.setItem('app-version', STORAGE_VERSION);
  }
}
